const WRAPPER_SELECTOR = ".wc-tabs-wrapper, .woocommerce-tabs";
const TAB_LINK_SELECTOR = ".wc-tabs li a, ul.tabs li a";

export function tabsEvents() {
	const wrappers = Array.from(document.querySelectorAll(WRAPPER_SELECTOR));
	if (!wrappers.length) return;

	const triggers = Array.from(document.querySelectorAll(TAB_LINK_SELECTOR));
	if (!triggers.length) return;

	let isLoading = false;
	let pendingTarget = null;

	async function firstClick(e) {
		e.preventDefault();
		const target =
			e.target instanceof Element ? e.target : e.target?.parentElement;
		if (target) {
			pendingTarget = target;
		}
		if (isLoading) {
			return;
		}
		isLoading = true;
		try {
			const { initWooTabs } = await import("./tabs.js");
			const openTabFromEvent = initWooTabs(wrappers);
			if (typeof openTabFromEvent === "function" && pendingTarget) {
				openTabFromEvent({
					target: pendingTarget,
					preventDefault: () => {},
				});
			}
			triggers.forEach((trigger) =>
				trigger.removeEventListener("click", firstClick)
			);
		} catch (err) {
			isLoading = false;
			console.error("Failed to load tabs module:", err);
		}
	}

	triggers.forEach((trigger) => trigger.addEventListener("click", firstClick));
}
